module.exports = __webpack_public_path__ + "static/media/Swiss721BT-BlackCondensed.a411d2bf.woff";